export const DOMSTRING = {
	content: 'main',
	excludedHeadlines: 'div.toc-exclude :is(h2, h3, h4, h5, h6)',
	tableOfContents: '.toc',
	tocMobile: '.toc--mobile',
};

export const anchorID = 'toc-';

export const mobileClass = 'toc--mobile';
